import i18next from 'i18next';
import * as bd from 'react-basic-design';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useAccount } from '../../app/account-context';
import settings from '../../app/settings';
import { RootState } from '../../app/stores/store';
import SvgDarkMode from '../../assets/icons/DarkMode';
import SvgHome from '../../assets/icons/Home';
import { code } from '../../components/basic/code';
import { T } from '../../components/basic/text';
import { CSSProperties } from 'react';

export function AppbarShell() {
    const userInfo = useSelector((state: RootState) => state.userInfo);
    const account = useAccount();
    const navigate = useNavigate();
    const toggleDarkMode = () =>
        bd.helper.setTheme(!bd.helper.isDarkMode() ? 'bd-quartz-dark' : 'bd-quartz-light');

    const setLang = (lang: string) => {
        bd.helper.setRTL(lang === 'fa');
        i18next.changeLanguage(lang);
    };

    const menuUser = (
        <bd.Menu className="shadow-5">
            <bd.MenuItem className="dropdown-item" onClick={() => navigate('/logout')}>
                <T>logout</T>
            </bd.MenuItem>
        </bd.Menu>
    );

    const toolbar_style: CSSProperties = { height: 52 };
    const link_style: CSSProperties = { color: '#fea', verticalAlign: 'middle' };
    const icon_style: CSSProperties = { color: '#fea', textShadow: '0 0 10px #ff0' };

    const button_style: CSSProperties = {
        padding: '3px 8px 3px 4px',
        backgroundColor: 'rgba(255,255,255, .12)',
    };

    const display_name_style: CSSProperties = { maxWidth: 180, fontSize: '0.75rem' };

    return (
        <>
            <bd.AppBar className="bg-shell text-shell">
                <bd.Toolbar size="md" style={toolbar_style}>
                    <div className="appbar-title">
                        <h5>
                            <Link
                                to={account.isConnected() ? '/home' : '/'}
                                className=" text-decoration-none "
                                style={link_style}
                            >
                                {!account.isConnected() && (
                                    <SvgHome style={icon_style} className="m-e-3 edge-start" />
                                )}
                                <T title={settings.version}>{settings.title}</T>
                            </Link>
                        </h5>
                    </div>

                    <>
                        <bd.Button
                            variant="text"
                            color="inherit"
                            onClick={() => setLang('fa')}
                            className="d-none d-lg-block"
                        >
                            فا
                        </bd.Button>

                        <bd.Button
                            variant="text"
                            color="inherit"
                            onClick={() => setLang('en')}
                            className="d-none d-lg-block"
                        >
                            EN
                        </bd.Button>

                        <bd.Button
                            variant="icon"
                            color="inherit"
                            onClick={toggleDarkMode}
                            className="d-none d-lg-block"
                        >
                            <SvgDarkMode />
                        </bd.Button>
                    </>
                    {account.isConnected() && (
                        <>
                            <bd.Button
                                variant="icon"
                                pill
                                color="inherit"
                                menu={menuUser}
                                className="d-none d-sm-block border  h-auto"
                                disableRipple
                                edge="end"
                                style={button_style}
                            >
                                <span
                                    className="m-e-2 d-none d-md-inline-block"
                                    style={display_name_style}
                                >
                                    {userInfo.displayName}
                                </span>
                            </bd.Button>
                        </>
                    )}
                </bd.Toolbar>
            </bd.AppBar>
        </>
    );
}
